import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { UiButton } from "../button";

import "./modal.scss";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

interface UiModalProps {
  children: React.ReactNode;
  title: string;
  visible: boolean;
  showActions?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  className?: string;
  onClose: () => void;
  onCancel?: () => void;
  onOk?: () => void;
}

export function UiModal({
  children,
  title,
  visible = false,
  showActions = false,
  maxWidth = "sm",
  className,
  onCancel,
  onClose,
  onOk,
}: UiModalProps) {
  // const [maxWidth, setMaxWidth] = React.useState<DialogProps["maxWidth"]>("sm");

  return (
    <BootstrapDialog
      onClose={onClose}
      aria-labelledby="ui-modal-dialog-title"
      open={visible}
      fullWidth={true}
      maxWidth={maxWidth}
      style={{ zIndex: 90 }} // Ensure modal is above other elements
      className={`ui-modal ${className || ""}`}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="ui-modal-dialog-title">
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>{children}</DialogContent>
      {showActions && (
        <DialogActions>
          <UiButton onClick={onCancel}>Annuler</UiButton>
          <UiButton onClick={onOk}>Valider</UiButton>
        </DialogActions>
      )}
    </BootstrapDialog>
  );
}
